import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Textarea, bordered when empty and a borderless filled card once populated.
 *
 * CSS selector: `mobile/atoms.css` `.ds-textarea` (+ `--filled`).
 *
 * Doctrine: borderless cards with tone-lift depth. Once the field holds a value
 * the border retires and the surface lifts instead. The CSS does not derive
 * this from `:placeholder-shown`, so `filled` is an explicit prop the consumer
 * flips, which keeps the behaviour predictable in controlled forms.
 */
export const Textarea = React.forwardRef(function Textarea(
  { className, filled = false, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn('ds-textarea', filled && 'ds-textarea--filled', className)}
      {...rest}
    />
  );
});

export default Textarea;
